import * as React from 'react';
import {
  Button,
  makeStyles,
  Theme,
  createStyles,
  Grid,
} from '@material-ui/core';
import clsx from 'clsx';

interface PickerBtnProps {
  title: string;
  selected?: boolean;
  onPick();
}

const pickerBtnStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '50%',
      height: '40px',
      background: '##D4D8DC',
      color: '#12161A',
      fontFamily: 'Proxima-Nova-Regular',
      borderRadius: '6px',
      textTransform: 'initial',
      fontSize: '12px',
      margin: '0px 8px 0px 0px',
      boxShadow: 'none',
      '&:hover': {
        background: '#505B63',
        color: 'white',
      },
      '& .MuiButton-label': {
        height: '28px',
        width: '126px',
        fontFamily: 'ProximaNova-Bold',
        fontSize: '15px',
        lineHeight: '14px',
        textAlign: 'center',
      },
    },
    selected: {
      background: '#3E4142',
      color: '#FFFFFF',
    },
    control: {
      padding: theme.spacing(2),
    },
    searchFilter: {
      [theme.breakpoints.only('sm')]: {
        width: '85px',
      },
      marginRight: '16px',
    },
  }),
);

export default function CancelButton(props) {
  const classes = pickerBtnStyles();
  if (props.title) {
    return (
      <Button
        className={clsx(classes.root)}
        onClick={props.onClick}
        fullWidth
        variant="contained"
      >
        {props.title}
      </Button>
    );
  } else {
    return null;
  }
}
